import { render, staticRenderFns } from "./Step3.vue?vue&type=template&id=3c8d5b67&"
import script from "./Step3.vue?vue&type=script&lang=ts&"
export * from "./Step3.vue?vue&type=script&lang=ts&"
import style0 from "./Step3.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports